var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ac-cropper-container"},[_c('div',{staticClass:"ac-cropper-header"},[_vm._v(" Use the slider to adjust the logo size on the member's home screen ")]),_c('cropper',{ref:"cropper",staticClass:"cropper",attrs:{"background-class":"cropper__background","foreground-class":"cropper__foreground","image-restriction":"stencil","src":_vm.cropperPreview,"stencil-size":_vm.stencilSize,"stencil-props":{
      lines: {},
      handlers: {},
      movable: false,
      scalable: false,
      aspectRatio: 1,
      previewClass: 'cropper__stencil',
    },"min-width":150,"min-height":150,"debounce":false,"transitions":false,"default-size":_vm.defaultSize,"move-image":false},on:{"change":_vm.onChange}}),_c('CropperZoomer',{attrs:{"zoom":_vm.zoom},on:{"change":_vm.onZoom}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }